import React, { Fragment } from "react";
import "./Credentials.css";
import EditPencilIcon from "../../assets/EditPencilIcon.svg";
import credentailsDp from "../../assets/credentailsDp.png";
import credentailsCamreaIcon from "../../assets/credentailsCamreaIcon.png";
import Sidebar from "../../common/Sidebar3rd/Sidebar";
import $ from "jquery";
import { NavLink } from "react-router-dom";
const Credentials1 = () => {
  const DisableHandler = () => {
    $(".DropDownCheck").toggleClass("d-none");
  };
  return (
    <Fragment>
      <div className="container-fluid credentailsBg mb-5">
        <div className="row">
          <Sidebar />
          <div className="col-md-12 ms-auto ">
            <div className="container-fluid px-0">
              <div className="row">
                <div className="credentailsHeaderBg">
                  <button className="credentailsHeaderBtn">
                    <img src={EditPencilIcon} className="me-3" alt="" />
                    <span className="CredentailsBannerSpan">
                      Edit Banner Photo
                    </span>
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-11 max-widthCredentails mx-auto">
                  <span className="credentailsDpWrapper">
                    <NavLink to="">
                      <img
                        className="credentailsDp"
                        src={credentailsDp}
                        alt=""
                      />
                    </NavLink>
                    <NavLink to="">
                      <img
                        className="credentailsDpIcon"
                        src={credentailsCamreaIcon}
                        alt=""
                      />
                    </NavLink>
                  </span>
                  <form className="pb-5">
                    <div className="row">
                      <div className="col-md-3 px-0 d-flex align-items-center">
                        <label
                          className="credentailsInputLabel mb-3 mb-md-0"
                          for=""
                        >
                          UserName
                        </label>
                      </div>
                      <div className="col-md-9 px-0">
                        <input
                          className="credentailsInputField"
                          type="text"
                          placeholder="Chowdhury Joy"
                        />
                        <p className="credentailsInputPara">
                          Example: Rakesh Roshan
                        </p>
                      </div>
                    </div>

                    <div className="row my-3">
                      <div className="col-md-3 px-0 d-flex align-items-center">
                        <label
                          className="credentailsInputLabel mb-3 mb-md-0"
                          for=""
                        >
                          Role
                        </label>
                      </div>
                      <div className="col-md-9 px-0 PR">
                        <span
                          className="CreateBtnWrapers w-100"
                          onClick={DisableHandler}
                        >
                          <input
                            className="credentailsInputField we3input"
                            type="text"
                          />
                        </span>
                        <div className="DropDownCheck shadow d-none">
                          <div className="FirstRow">
                            <div className="Lefts">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Producer</label>
                            </div>
                            <div className="Rights">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Mastering Engineer</label>
                            </div>
                          </div>
                          <div className="FirstRow">
                            <div className="Lefts">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Instrumentalist</label>
                            </div>
                            <div className="Rights">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Static Graphic Designer</label>
                            </div>
                          </div>
                          <div className="FirstRow">
                            <div className="Lefts">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Vocalist/Rapper</label>
                            </div>
                            <div className="Rights">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Motion Graphic Designer</label>
                            </div>
                          </div>
                          <div className="FirstRow">
                            <div className="Lefts">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">
                                Mixing/Arrangement Engineer
                              </label>
                            </div>
                            <div className="Rights">
                              <input
                                type="checkbox"
                                className="form-check-input form-check-box2- CheckBox"
                              />
                              <label htmlFor="">Web3 Music Collector</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-3 px-0 d-flex align-items-center">
                        <label
                          className="credentailsInputLabelTwitter mb-3 mb-md-0"
                          for=""
                        >
                          Twitter Link
                        </label>
                      </div>
                      <div className="col-md-6 px-0">
                        <input className="credentailsInputField" type="text" />
                        <p className="credentailsInputPara">
                          Example: https://twitter.com/username
                        </p>
                      </div>
                      <div className="col-md-3 d-flex align-items-center justify-content-end px-0">
                        <button className="credentailsVerifyBtn marginB4 mt-md-0 mt-3">
                          Verify
                        </button>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-3 px-0 d-flex align-items-center">
                        <label
                          className="credentailsInputLabel mb-3 mb-md-0"
                          for=""
                        >
                          Instagram Link
                        </label>
                      </div>
                      <div className="col-md-9 px-0">
                        <input className="credentailsInputField" type="text" />
                        <p className="credentailsInputPara">
                          Example: https://instagram.com/username
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Credentials1;
